import { CssBaseline, ThemeProvider } from "@mui/material";
import StyledEngineProvider from "@mui/material/StyledEngineProvider";
import { createCustomTheme } from "./theme";
import "./i18n";
import "moment/locale/id";
import Routes from "./routes";
import { Toaster } from "react-hot-toast";
import DynamicHead from "components/DynamicHead";

const App = () => {
  const theme = createCustomTheme({
    theme: "light",
    direction: "ltr",
    responsiveFontSizes: true,
  });

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
      <DynamicHead />
        <CssBaseline />
        <Routes />
        <Toaster />
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
